// Mirrors _features/company/state/slice.js's shape (selectedFilters +
// customColumns, REHYDRATE normalization). Deliberately does NOT carry
// forward that file's `companies`/`setCompanies` field - confirmed unread
// anywhere in this codebase (RTK Query's own cache is the source of truth
// for list data; nothing selects `state.companyFeature.companies`), so this
// new slice isn't given the same dead write-only field.
//
// Separate Redux key (`subscriptionsFeature`, plural) from the legacy
// `subscription` slice (`features/Subscription/SubscriptionReducer.js`,
// singular) - that old slice stays registered for its own remaining
// consumers (CustomerDetails, SelfServeDetails), see docs/known-issues.md.
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const initialState = {
  selectedFilters: {
    sort: "-createdAt",
  },
};

const subscriptionsFeatureSlice = createSlice({
  name: "subscriptionsFeature",
  initialState,
  reducers: {
    updateSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    },
    resetSelectedFilters: (state) => {
      state.selectedFilters = {
        sort: "-createdAt",
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.subscriptionsFeature) {
        const persistedData = action.payload.subscriptionsFeature;
        const persistedSort = persistedData.selectedFilters?.sort;

        return {
          ...state,
          ...persistedData,
          selectedFilters: {
            ...persistedData.selectedFilters,
            sort: persistedSort || "-createdAt",
          },
        };
      }
      return state;
    });
  },
});

export const { updateSelectedFilters, resetSelectedFilters } =
  subscriptionsFeatureSlice.actions;

export default subscriptionsFeatureSlice.reducer;
